'use client'
import { motion } from 'motion/react'
import { useEffect, useState } from 'react'

export const Background = () => {
  const [mousePosition, setMousePosition] = useState({ x: 50, y: 50 })

  useEffect(() => {
    const handleMouseMove = e => {
      const x = e.clientX || e.touches?.[0]?.clientX || 0
      const y = e.clientY || e.touches?.[0]?.clientY || 0

      setMousePosition({
        x: (x / window.innerWidth) * 100,
        y: (y / window.innerHeight) * 100
      })
    }

    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('touchmove', handleMouseMove, { passive: true })

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('touchmove', handleMouseMove)
    }
  }, [])

  return (
    <div className='fixed inset-0 -z-10 overflow-hidden group' role='presentation' aria-hidden='true'>
      <motion.div
        className='absolute inset-0 transition-all duration-300 group-hover:backdrop-blur-sm'
        role='presentation'
        aria-hidden='true'
        style={{
          background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, 
                        rgba(253, 224, 71, 0.9) 0%, transparent 20%),
                        radial-gradient(at 80% 0%, rgba(34, 197, 94, 0.4) 0%, transparent 50%),
                        radial-gradient(at 0% 50%, rgba(16, 185, 129, 0.5) 0%, transparent 50%),
                        radial-gradient(at 80% 50%, rgba(250, 204, 21, 0.3) 0%, transparent 50%),
                        radial-gradient(at 0% 100%, rgba(22, 163, 74, 0.4) 0%, transparent 70%)`
        }}
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        transition={{
          type: 'spring',
          stiffness: 400,
          damping: 240,
          mass: 2
        }}
      />
    </div>
  )
}

export default Background
